import React from 'react';
import {BED_HEIGHT, BED_WIDTH} from '../../ward/map/mapState';
import {useTheme} from '@mui/material/styles';
import _ from 'lodash';

const WardCardThumbnail = ({elements = [], width, height}) => {
    const theme = useTheme();

    if (elements.length === 0) return null;

    return (
        <svg
            fill="red"
            width="100%"
            height="100%"
            viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio="xMidYMid meet"
        >
            {elements.map((element) => (
                <rect
                    key={element.uniqId}
                    x={Number(element.x)}
                    y={Number(element.y)}
                    width={(!_.isEmpty(element?.width) && element?.width !== '0') ? Number(element.width) : BED_WIDTH}
                    height={(!_.isEmpty(element?.height) && element?.height !== '0') ? Number(element.height) : BED_HEIGHT}
                    fill={theme.palette.mode === 'light' ? '#a4a4a4' : '#f0f0f0'}
                />
            ))}
        </svg>
    );
};


export default React.memo(WardCardThumbnail);